import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useCourseStore } from "../../stores/course.store";
import { useSeasonStore } from "../../stores/season.store";
import { TemporarySubscription } from "../../types/course";

export function CoursesLayout() {
  const { currentSeason } = useSeasonStore();
  const { currentCourse } = useCourseStore();
  const [tempSubscriptions, setTempSubscriptions] = useState<
    Map<string, TemporarySubscription>
  >(new Map());

  useEffect(() => {
    if (!currentSeason || !currentCourse) {
      setTempSubscriptions(new Map());
    }
  }, [currentSeason, currentCourse]);

  return (
    <Outlet
      context={{
        tempSubscriptions,
        setTempSubscriptions,
      }}
    />
  );
}
